import { EPartnerType, IPartner } from '../models/partner.model';
import { IPaginationData, IPaginationQuery, request } from './base';

const prefix = '/partners';

function getList(
  query: IPaginationQuery & {
    type: EPartnerType;
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
  },
) {
  return request<IPaginationData<IPartner>>({
    url: `${prefix}/listing`,
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<IPartner>({
    url: `${prefix}/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<IPartner>) {
  return request<IPartner>({
    url: prefix,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<IPartner>) {
  return request<IPartner>({
    url: `${prefix}/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<IPartner>({
    url: `${prefix}/${id}`,
    method: 'DELETE',
  });
}

const partnerApi = Object.freeze({
  getList,
  getDetail,
  update,
  create,
  remove,
});

export default partnerApi;
